import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import GamesContainer from './containers/GamesContainer';
import GameCreateContainer from './containers/GameCreateContainer';
import GameEditContainer from './containers/GameEditContainer';

import './App.css';
import Navigation from './components/common/Navigation';
import PrivateRoute from './components/common/PrivateRoute';
import MyGamesContainer from './containers/MyGamesContainer';
import PlayersAdminContainer from './containers/PlayersAdminContainer';
import { About } from './components/about/About';
import PlayerCreateContainer from './containers/PlayerCreateContainer';
import PlayerEditContainer from './containers/PlayerEditContainer';
import GameDeleteContainer from './containers/GameDeleteContainer';
import PlayerDeleteContainer from './containers/PlayerDeleteContainer';
import { Play } from './components/play/Play';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <main className="container">
            <Navigation />
            <Route exact path="/" component={Play} match="exact" />
            <Route exact path="/games" component={GamesContainer} />
            <Route exact path="/about" component={About} />
            <Route path="/play/:id?" component={Play} />
            <PrivateRoute  path="/game/create" component={GameCreateContainer}  />
            <PrivateRoute  path='/game/edit/:id' component={GameEditContainer}  />
            <PrivateRoute path="/game/delete/:id" component={GameDeleteContainer} />
            <PrivateRoute path="/mygames" component={MyGamesContainer} />
            <PrivateRoute path="/players/admin/:id" component={PlayersAdminContainer} />
            <PrivateRoute path="/player/create/:id" component={PlayerCreateContainer}  />
            <PrivateRoute path="/player/edit/:id/:playerId" component={PlayerEditContainer }  />
            <PrivateRoute path="/player/delete/:id/:playerId" component={PlayerDeleteContainer} />
          </main>
        </div>
      </BrowserRouter>
    );
  }
}


export default App;